import ReflectionUtils from '../reflection/ReflectionUtils';
import RuntimeUtils from '../system/RuntimeUtils';
let globalScope;
if (RuntimeUtils.isNode()) {
    globalScope = global;
}
else {
    globalScope = window;
}
globalScope.nameOf = ReflectionUtils.nameOf;
//# sourceMappingURL=GlobalExtensions.js.map